module.exports = __webpack_public_path__ + "static/media/jpg.650ad5ca.svg";